module.exports = __webpack_public_path__ + "img/tablet.fa488b10.svg";